import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RoutingService } from '@spartacus/core';
import { SearchBoxConfig } from '@spartacus/storefront';
import { Subscription } from 'rxjs';
import { OspCategoriesService } from '../services/osp-categories.service';

const DEFAULT_SEARCH_BOX_CONFIG: SearchBoxConfig = {
  minCharactersBeforeRequest: 3,
  maxProducts: 5,
};

@Component({
    selector: 'app-custom-osp-search-result-footer',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './custom-osp-search-result-footer.component.html',
    standalone: false
})
export class CustomOspSearchResultFooterComponent implements OnInit, OnDestroy {
  query: string;
  resultPresent = true;
  contentSub: Subscription;

  constructor(
    private readonly router: RoutingService,
    private readonly ospService: OspCategoriesService,
    protected readonly changeDetectorRef: ChangeDetectorRef,
    private readonly route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.contentSub = this.ospService.contentItemsSearchResult$.subscribe(
      (res) => {
        if (res != null) {
          this.resultPresent = res.products.length > 0;
          this.changeDetectorRef.detectChanges();
        } else {
          this.resultPresent = false;
          this.changeDetectorRef.detectChanges();
        }
      }
    );
  }
  ngOnDestroy(): void {
    this.contentSub?.unsubscribe();
  }

  redirectToHelpCenter() {
    this.router.goByUrl('/help-center/all');
    window.scrollTo(0, 0);
  }
}
